export default __webpack_public_path__ + "static/media/table2.c7649f5d.png";